export default __webpack_public_path__ + "static/media/640_portfolio04-it-mobile.e0ed5fc6.png";